/* eslint-disable no-irregular-whitespace */
const replacements = [
	[/[   ]/g, ''],
	[/[–]/g, '-']
] as const;

export function clean(text: string): string {
	for (const [search, replace] of replacements) {
		text = text.replaceAll(search, replace);
	}
	return text;
}

export function parseHoursOfOperation(hours: string): string[] {
	return clean(hours)
		.split(/[;.\n,]/)
		.reduce((accum: string[], entry) => {
			const trimmed = entry.trim();
			return trimmed !== '' ? [...accum, trimmed] : accum;
		}, []);
}
